import React from 'react';
import FormField from '../FormField/FormField';

const UserLoginForm = ({
  activeForm,
  formData,
  handleChange,
  handleSubmit,
  toggleForm,
}) => {
  const fields = [
    {
      label: 'Ваш логин',
      type: 'text',
      name: 'login',
      placeholder: 'Введите логин',
    },
    {
      label: 'Пароль',
      type: 'password',
      name: 'password',
      placeholder: 'Введите пароль',
    },
  ];

  return (
    <div
      className={`auth-forms__form ${activeForm === 'sign-in' ? 'show' : ''
        } auth-forms__form_login`}
    >
      <h2 className='auth-forms__title'>Вход</h2>
      <form
        onSubmit={handleSubmit}
        className='auth-forms__form-container'
        autoComplete='off'
      >
        {fields.map(({ label, type, name, placeholder }, index) => (
          <FormField
            key={`${name}+ ${index}`}
            label={label}
            type={type}
            name={name}
            value={formData[name] || ''}
            onChange={handleChange}
            placeholder={placeholder}
            error={formData.errors?.[name]}
          />
        ))}

        <button
          disabled={!formData.login || !formData.password}
          type='submit'
          className='auth-forms__button'
        >
          Войти
        </button>
      </form>

      <p className='auth-forms__text'>
        Нет аккаунта?{' '}
        <span
          className='auth-forms__link'
          onClick={() => toggleForm('register')}
        >
          Зарегистрироваться
        </span>
      </p>
    </div>
  );
};

export default UserLoginForm;
